import { FormControl, FormHelperText } from "@mui/material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const outputFormat = "YYYY-MM-DD";

export default function DatePicker(props) {
  const {
    width,
    name,
    onChange,
    required,
    readOnly,
    error,
    helperText,
    value,
    variant,
    disabled,
  } = props;
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(
    value ? moment(value, outputFormat) : null
  );

  function onDateChange(newDate) {
    setSelectedDate(newDate);
    onChange({
      target: {
        name: name,
        value: newDate ? newDate.format(outputFormat) : "",
      },
    });
  }

  return (
    <FormControl
      variant={variant || "outlined"}
      sx={{
        width: width || "100%",
      }}
      required={required}
      {...(error && { error: true })}
    >
      <MuiDatePicker
        label={
          <span style={{ fontWeight: "bold" }}>{t(`FORM.FIELD.${name}`)}</span>
        }
        variant={variant || "outlined"}
        value={selectedDate}
        name={name}
        onChange={onDateChange}
        slotProps={{
          textField: {
            ...(error && { error: true }),
          },
        }}
        // format="D/M/Y"
        sx={{
          width: "100%",
        }}
        readOnly={readOnly}
        {...(error && { error: true })}
        disableFuture
        disabled={disabled}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
